/** 컨테이너 배차일보 자동완성 마스터 카테고리 */

export const CONTAINER_MASTER_CATEGORIES = [
  'shipper',
  'region',
  'line',
  'terminal',
] as const;

export type ContainerMasterCategory = typeof CONTAINER_MASTER_CATEGORIES[number];

export const CONTAINER_MASTER_TAB_LABELS: Record<ContainerMasterCategory, string> = {
  shipper: '도착 창고 및 업체',
  region: '도착지역',
  line: 'LINE',
  terminal: '반출 / 반납터미널',
};

export interface ContainerMasterRow {
  id: string;
  category: ContainerMasterCategory;
  value: string;
  remarks: string;
  sortOrder: number;
}

export interface ContainerMasterGrouped {
  shipper: string[];
  region: string[];
  line: string[];
  terminal: string[];
}

export const EMPTY_CONTAINER_MASTER_GROUPED: ContainerMasterGrouped = {
  shipper: [],
  region: [],
  line: [],
  terminal: [],
};
